/**
 * 参考视频 Demo 素材库（多产品共用，存于 R2 demo-reference-videos/ 前缀）。
 * 每条素材 = demo-XX.mp4 + demo-XX-poster.jpg 封面，全部 ≤15s（符合参考视频时长预算）。
 */

const CDN_BASE = 'https://cdn.treekee.com/demo-reference-videos';

const TOTAL = 55;

// 实测时长（秒）；未列出的均为 5.0
const DURATIONS: Record<number, number> = {
  5: 10.7,
  8: 3.4,
  10: 3.7,
  11: 4.9,
  22: 9.3,
  23: 6.9,
  24: 7.8,
  25: 7.2,
  26: 5.2,
  27: 8.1,
  28: 7.8,
};

export interface DemoReferenceVideo {
  id: string;
  url: string;
  poster: string;
  duration: number;
}

export const DEMO_REFERENCE_VIDEOS: DemoReferenceVideo[] = Array.from(
  { length: TOTAL },
  (_, i) => {
    const n = i + 1;
    const id = `demo-${String(n).padStart(2, '0')}`;
    return {
      id,
      url: `${CDN_BASE}/${id}.mp4`,
      poster: `${CDN_BASE}/${id}-poster.jpg`,
      duration: DURATIONS[n] ?? 5,
    };
  },
);
